export const annualIncomeValidate = (totalObligation, income) => {
  let requiredIncome = 0;
  let percentageText = "";
  // Up to 10 lac → 125%
  if (totalObligation <= 1000000) {
    requiredIncome = totalObligation * 1.30;
    percentageText = totalObligation * 1.30;
  }
  // >10 to 20 lac → 100%
  else if (totalObligation <= 2000000) {
    requiredIncome = totalObligation * 1;
    percentageText = totalObligation * 1;
  }
  // >20 to 30 lac → 80%
  else if (totalObligation <= 3000000) {
    requiredIncome = totalObligation * 0.8;
    percentageText = totalObligation * 0.8;
  }
  // Above 30 lac → 70%
  else {
    requiredIncome = totalObligation * 0.7;
    percentageText = totalObligation * 0.7;
  }
  return {
    isValid: income >= requiredIncome,
    percentageText,
  };
};

export const isEmpty = (val) => !val || val.toString().trim() === "";

export const validateFamilyDetails = (familyList, toastUpdate, editable) => {
    const incompleteMembers = familyList.some((item) => {
      return (
        isEmpty(item.name) ||
        isEmpty(item.relationship) ||
        isEmpty(item.mobileNumber) ||
        item.mobileNumber.length !== 10 ||
        isEmpty(item.income) ||
        Number(item.income) <= 0
      );
    });

    if (incompleteMembers) {
      toastUpdate("Error", "Both family details are mandatory", true);
      return false;
    }
    if (editable) {
      const hasUnsavedData = familyList.some((item) => {
        const hasValues =
          !isEmpty(item.name) ||
          !isEmpty(item.relationship) ||
          !isEmpty(item.mobileNumber) ||
          !isEmpty(item.income);
        return hasValues && !item.isLocked;
      });

      if (hasUnsavedData) {
        toastUpdate(
          "Error",
          "Please save all entered family details before proceeding",
          true
        );
        return false;
      }
    }

    return true;
  };